'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "pixelValue"],
  _excluded2 = ["tooltip", "label", "disabled", "onChange", "onStep", "allowUnitDimensions", "pixelValue"];
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { isPercentage, percentageStringToNumber, pixelStringToNumber } from '../../utils/table';
import { PercentageStepperInput, PixelStepperInput, SplitStepperInput } from '../steppers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnitSplitStepperInput = props => {
  const {
      value,
      pixelValue
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (isPercentage(value)) {
    return /*#__PURE__*/_jsx(PercentageStepperInput, Object.assign({}, rest, {
      size: 7,
      value: percentageStringToNumber(value)
    }));
  } else {
    return /*#__PURE__*/_jsx(PixelStepperInput, Object.assign({}, rest, {
      size: 7,
      value: pixelStringToNumber(pixelValue)
    }));
  }
};
const StyledLabel = styled.div.withConfig({
  displayName: "SplitLabelStepperInput__StyledLabel",
  componentId: "sc-1p635fn-0"
})(({
  $disabled,
  theme
}) => {
  return {
    blockSize: '32px',
    lineHeight: '30px',
    fontWeight: theme.typography['heading-25'].fontWeight,
    fontSize: theme.typography['heading-25'].fontSize,
    color: $disabled ? theme.color['border-tertiary-default'] : theme.color['text-core-default']
  };
});
const propTypes = {
  tooltip: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onStep: PropTypes.func.isRequired,
  allowUnitDimensions: PropTypes.bool,
  pixelValue: PropTypes.number
};
const defaultProps = {
  size: 5,
  stepSize: 1,
  min: 0
};
function SplitLabelStepperInput(props) {
  const {
      tooltip,
      label,
      disabled,
      onChange,
      onStep,
      allowUnitDimensions,
      pixelValue
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  const handleChange = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onChange(updatedValue);
  };
  const handleStep = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onStep(updatedValue);
  };
  const ComputedStepperInput = allowUnitDimensions ? UnitSplitStepperInput : SplitStepperInput;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltip,
    placement: "bottom",
    disabled: disabled,
    children: /*#__PURE__*/_jsxs(InputGroup, {
      use: "none",
      children: [/*#__PURE__*/_jsx(FormControl, {
        "aria-label": "split-stepper-label",
        backgroundColor: disabled ? 'fill-tertiary-disabled' : 'fill-field-default',
        borderStartStartRadius: "100",
        borderEndStartRadius: "100",
        borderWidth: "100",
        borderStyle: "solid",
        borderColor: "border-core-default",
        blockSize: "32px",
        inlineSize: "22px",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(StyledLabel, {
          $disabled: disabled,
          children: label
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": "split-stepper-input",
        children: /*#__PURE__*/_jsx(ComputedStepperInput, Object.assign({}, rest, {
          inlineSize: "110px",
          pixelValue: allowUnitDimensions ? pixelValue : undefined,
          disabled: disabled,
          onChange: handleChange,
          onStep: handleStep
        }))
      })]
    })
  });
}
SplitLabelStepperInput.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SplitLabelStepperInput.defaultProps = defaultProps;
SplitLabelStepperInput.displayName = 'SplitLabelStepperInput';
export default SplitLabelStepperInput;